<breadcrumbs [path]="breadcrumbs"></breadcrumbs>

@if (model && model.requestType) {
<div>
  <div class="row">
    <div class="col-6">
      <h1 class="mb-3 mt-0">{{localize(langSection.RequestDetailsPage, langText.Header)}}</h1>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <h3>{{localize(langSection.RequestDetailsPage, langText.GeneralInformation)}}</h3>
      <p class="m-0"><strong>{{localize(langSection.Term, langText.Location)}}: </strong>@if (locationProfile) {
<span>{{locationProfile.slicName}} ({{locationProfile.customName}})</span>
}</p>
      <p class="m-0"><strong>{{localize(langSection.RequestDetailsPage, langText.RequestId)}}:</strong> {{model.requestId}}</p>
      @if (model.pickUpNumber && model.pickUpNumber !== '0') {
<p class="m-0"><strong>{{localize(langSection.RequestDetailsPage, langText.PickupNumber)}}:</strong> {{model.pickUpNumber}}</p>
}
      @if (model.deliveryNumber && model.deliveryNumber !== '0') {
<p class="m-0"><strong>{{localize(langSection.RequestDetailsPage, langText.DeliveryNumber)}}:</strong> {{model.deliveryNumber}}</p>
}
      <p class="m-0"><strong>{{localize(langSection.RequestDetailsPage, langText.RequestInstructions)}}:</strong> {{model.specialInstructions}}</p>
    </div>
  </div>

  @if (audit && audit.auditEntries) {
<div>
    @for (auditEntry of audit.auditEntries; track auditEntry) {
<div class="row mt-4">
      <div class="col-6">
        <h3>{{getEventType(auditEntry.type)}}</h3>
        <p class="m-0"><strong>{{getEventType(auditEntry.type)}} {{localize(langSection.Term, langText.By)}}:</strong> {{auditEntry.user}}</p>
        <p class="m-0"><strong>{{localize(langSection.Term, langText.Date)}}:</strong> {{auditEntry.timestamp | localizedDate:'M/D/yy, h:mm A':"yyyy/MM/DD HH:mm"}}</p>
        @if (auditEntry.reason && auditEntry.reason !== '') {
<p class="m-0"><strong>{{localize(langSection.RequestDetailsPage, langText.Reason)}}:</strong> {{auditEntry.reason}}</p>
}
        @for (fieldValuePair of auditEntry.fieldValuePairs; track fieldValuePair) {
<div>
          @if (fieldValuePair.field === 'Earliest' || fieldValuePair.field === 'Latest') {
            <p class="m-0"><strong>{{localizeField(fieldValuePair.field)}}:</strong> {{fieldValuePair.value | localizedDate: 'M/D/yy, h:mm A':"yyyy/MM/DD HH:mm"}}</p>
          }
          @else {
            @if (auditEntry.type !== 'Canceled') {
<p class="m-0">@if (fieldValuePair.field !== '') {
<strong >{{localizeField(fieldValuePair.field)}}:</strong>
} {{localizeValue(fieldValuePair.field, fieldValuePair.value)}}</p>
}
            @if (auditEntry.type === 'Canceled') {
<p class="m-0">@if (fieldValuePair.field !== '') {
<strong >{{localizeField(fieldValuePair.field)}}:</strong>
} {{localizeCancelReasonString(fieldValuePair.value)}}</p>
}
          }
        </div>
}
      </div>
    </div>
}
  </div>
}

  <div class="row mt-4">
    <div class="col-3">
      <button class="py-2 px-5 border-0 text-white bg-green me-4 round-button" (click)="onContinue()">{{localize(langSection.Term, langText.Continue)}}</button>
    </div>
  </div>
</div>
}
